export default {

    iControlVersion: "3.0.0-rc7.5.4"

}
